module.exports = __webpack_public_path__ + "ec5f241e83fdc91096f1b7796fddd992.png";